<template>
    <div class="chat-profile-header">
        <div class="chat-profile-header__back" @click="$router.push({ path: '/chat' })">
            <i class="ri-arrow-left-s-line"></i>
        </div>

        <div class="chat-profile-header__photo">
            <a v-if="relatedUser" href="#" @click.prevent="$emit('see-contact-info')" target="_blank">
                <img v-if="relatedUser.attributes.image_url" :src="relatedUser.attributes.image_url" alt="avatar" />
                <svg v-else width="18" height="20" viewBox="0 0 18 20">
                    <use xlink:href="#svg-icn-user"></use>
                </svg>
            </a>
            <svg v-else width="18" height="20" viewBox="0 0 18 20">
                <use xlink:href="#svg-icn-user"></use>
            </svg>
        </div>

        <div class="chat-profile-header__name">
            <a href="#" @click.prevent="$emit('see-contact-info')"
                ><strong>{{ handleTwilioUserNameOf(relatedUser) }}</strong></a
            >
            <div class="chat-profile-header__ad">
                <span class="ad-short-title"> {{ conversation.attributes.advert_rooms }} bed, {{ conversation.attributes.advert_outcode }} </span>
                <span class="ad-long-title">
                    {{ conversation.friendlyName }}
                </span>
            </div>
        </div>
        <div class="chat-profile-header__actions">

            <a
                v-if="relatedUserData && primaryPhoneNumberE164"
                class="chat-profile-header__phone"
                :href="relatedUserData && `tel:${primaryPhoneNumberE164}`"
                @click="startPhoneCall">
                <img src="/img/icons/audio-call-icon.png" width="30" height="30" alt="Audio call" />
            </a>
            <div class="chat-profile-header__more">
                <a href="#" @click.prevent="showOptionsDropdown = !showOptionsDropdown">
                    <svg xmlns="http://www.w3.org/2000/svg" width="5" height="19" viewBox="0 0 5 19" fill="none">
                        <circle cx="2.5" cy="16.5" r="2.5" transform="rotate(-90 2.5 16.5)" fill="#8A2BE2" />
                        <circle cx="2.5" cy="9.5" r="2.5" transform="rotate(-90 2.5 9.5)" fill="#8A2BE2" />
                        <circle cx="2.5" cy="2.5" r="2.5" transform="rotate(-90 2.5 2.5)" fill="#8A2BE2" />
                    </svg>
                </a>
                <div
                    class="chat-profile-header__more-dropdown"
                    v-if="showOptionsDropdown"
                    v-on-clickaway="
                        () => {
                            showOptionsDropdown = false;
                        }
                    ">
                    <a
                        :href="`/adverts/${conversation.attributes.advert_slug}`"
                        target="_blank"> Show ad </a>

                    <a href="#" @click.prevent="showReportModal = true"> Report </a>
                </div>
            </div>
        </div>

        <ReportConversationModal :show-modal="showReportModal" :conversation="conversation" @close="showReportModal = false" />
    </div>
</template>

<script>
import ReportConversationModal from '@/components/UserChat/partials/ReportConversationModal.vue';
import { handleTwilioUserNameOf } from '@helpers/helpers';
import { directive as onClickaway } from 'vue-clickaway2';
import { mapActions, mapState } from 'vuex';

export default {
    components: {
        ReportConversationModal,
    },
    props: {
        conversationsClient: {
            type: Object,
            required: true,
            default: null,
        },
        conversation: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            relatedUser: null,
            relatedUserData: null,
            showReportModal: false,
            showOptionsDropdown: false,
        };
    },
    watch: {
        conversation() {
            this.setRelatedUser();
        },
        relatedUser() {
            if (this.relatedUser && this.relatedUser.attributes.uuid) {
                this.axios.get(`/api/user?uuid=${this.relatedUser.attributes.uuid}`).then((response) => {
                    if (response.status === 200) this.relatedUserData = response.data.data;
                });

                this.getPhoneNumber({
                    userUuid: this.relatedUser.attributes.uuid,
                    isPrimaryPhoneNumber: true,
                    adUuid: this.conversation.attributes.advert_slug || null,
                });
            }
        },
    },
    created() {
        this.setRelatedUser();
    },
    directives: {
        onClickaway,
    },
    computed: {
        ...mapState('adDetails', ['primaryPhoneNumberE164']),
    },
    methods: {
        handleTwilioUserNameOf,
        ...mapActions('adDetails', ['getPhoneNumber', 'callPhoneNumber']),
        async setRelatedUser() {
            const chatUserAsParticipant = await this.conversation.getParticipantByIdentity(this.conversationsClient.user.identity);
            const conversationParticipants = await this.conversation.getParticipants();

            this.relatedUser = null;

            conversationParticipants.forEach(async (participant) => {
                const user = await participant.getUser();

                if (chatUserAsParticipant.identity === participant.identity) {
                    return;
                }
                if (user.attributes.is_deleted) {
                    return;
                }
                if (conversationParticipants.length === 2) {
                    this.relatedUser = user;
                } else if (conversationParticipants.length === 3) {
                    if (['agent', 'company'].includes(this.conversationsClient.user.attributes.account_type) && user.attributes.account_type === 'individual') {
                        this.relatedUser = user;
                    } else if (chatUserAsParticipant.attributes.group !== participant.attributes.group && !this.relatedUser) {
                        this.relatedUser = user;
                    }
                }
            });
        },
        startPhoneCall() {
            this.callPhoneNumber({ userUuid: this.relatedUser.attributes.uuid });
        },
    },
};
</script>
